/* eslint-disable */


import { REVIEW_STATUS } from '@/constants/reviewStatus'

export default {
  computed: {
    normalReviewIndeterminateStatus () {
      if (this.userIsInTransactionsSections) {
        return (this.reviewStatusApproved.checked && !this.reviewStatusPersonalExpense.checked) || (!this.reviewStatusApproved.checked && this.reviewStatusPersonalExpense.checked)
      }
      return (this.reviewStatusApproved.checked && !this.reviewStatusCancelled.checked) || (!this.reviewStatusApproved.checked && this.reviewStatusCancelled.checked)
    },
    funnelIndeterminateStatus () {
      if (this.allStepsSelected && this.reviewFilterDefaultFlow.checked) {
        return false
      }
      if (this.hasAnyStepSelected) {
        return true
      }
      return false
    },
    allSteps () {
      return this.reviewFlows.length ? this.reviewFlows.map(el => el.steps).flat(1) : []
    },

    hasAnyStepSelected () {
      return this.reviewFlowStep.length > 0 || this.reviewFilterDefaultFlow.checked
    },
    selectedStep () {
      return this.allSteps.findIndex(step => step.selected)
    },
    allStepsSelected () {
      let allStepsInReviewFlowStep = false
      this.allSteps.every(step => {
        if (this.reviewFlowStep.findIndex(el => el === step.id.toString()) > -1) {
          allStepsInReviewFlowStep = true
          return true
        } else {
          allStepsInReviewFlowStep = false
          return false
        }
      })
      return allStepsInReviewFlowStep
    },
    hasAnyReviewFilter () {
      return this.reviewFlowStep.length > 0 || this.reviewStatusFilter.length > 0
    },
    hasAllExpenseAprovalFilter () {
      return this.reviewStatusFilter.includes(REVIEW_STATUS.APPROVED) && this.reviewStatusFilter.includes(REVIEW_STATUS.CANCELLED)
    },
    hasAllTransactionsAprovalFilter () {
      return this.reviewStatusFilter.includes(REVIEW_STATUS.APPROVED) && this.reviewStatusFilter.includes(REVIEW_STATUS.PERSONAL_EXPENSE)
    },
    hasAllTransactionReviewChecks () {
      return this.reviewStatusApproved.checked && this.reviewStatusPersonalExpense.checked
    },
    reviewFlows () {
      return this.$store.getters['CompanyStore/TransactionFieldsStore/reviewFlows'] || []
    },

  },
  methods: {
    _initializeSelected () {
      this.reviewFlows.forEach(reviewFlow => {
        reviewFlow.steps.forEach(step => {
          step.selected = false
        })
      })
    },
    setReviewFlowStepType (reviewType) {
      if (reviewType === 'NORMAL') {
        this.reviewFilterTypeNormal.checked = !this.reviewFilterTypeNormal.checked
        this.setReviewFilters(reviewType)
      } else {
        this.reviewFilterTypeFunnel.checked = !this.reviewFilterTypeFunnel.checked
        this.setReviewFilters(reviewType)
      }
    },
    setReviewFilters (reviewType) {
      if (reviewType === 'NORMAL') {
        if (this.reviewFilterTypeNormal.checked) {
          this.reviewStatusApproved.checked = true
          if (this.userIsInTransactionsSections) {
            this.reviewStatusPersonalExpense.checked = true
            this.reviewStatusFilter.push(REVIEW_STATUS.PERSONAL_EXPENSE)
          } else {
            this.reviewStatusCancelled.checked = true
            this.reviewStatusFilter.push(REVIEW_STATUS.CANCELLED)
          }

          this.reviewStatusFilter.push(...[REVIEW_STATUS.APPROVED])
          
        } else {
          this.reviewStatusApproved.checked = false
          this.reviewStatusCancelled.checked = false
          this.reviewFilterTypeNormal.checked = false
          this.reviewStatusPersonalExpense.checked = false

          this.reviewStatusFilter = this.reviewStatusFilter.filter(el => el !== REVIEW_STATUS.APPROVED && el !== REVIEW_STATUS.CANCELLED && el !== REVIEW_STATUS.PERSONAL_EXPENSE)
          
        }
      } else {
        if (this.reviewFilterTypeFunnel.checked) {
          this.setAllStepsAsSelected()
        } else {
          this.setAllStepsAsNotSelected()
        }
      }
    },
    setAllStepsAsSelected () {
      this.reviewFilterDefaultFlow.checked = true
      this.reviewStatusFilter.push(REVIEW_STATUS.AWAITING_REVIEW)
      this.reviewFlows.forEach(el => {
        el.steps.forEach(step => {
          step.selected = true
        })
        this.reviewFlowStep.push(...el.steps.map(el => el.id.toString()))
      })
    },
    setAllStepsAsNotSelected () {
      this.reviewFilterDefaultFlow.checked = false
      this.reviewStatusFilter = this.reviewStatusFilter.filter(el => el !== REVIEW_STATUS.AWAITING_REVIEW)
      this.reviewFlows.forEach(el => {
        el.steps.forEach(step => {
          step.selected = false
        })
      })
      this.reviewFlowStep = []
    },
    setReviewFlowStep (step) {
      if (typeof this.reviewFlowStep === 'string' || !this.reviewFlowStep) this.reviewFlowStep = []
      const stepInReviewSteps = this.reviewFlowStep.findIndex(el => el === step.id.toString()) !== -1
      if (!stepInReviewSteps) {
        this.reviewFlowStep.push(step.id.toString())
      } else {
        this.reviewFlowStep = this.reviewFlowStep.filter(el => el !== step.id.toString())
      }
      this._checkAllStepsSelected()
    },
    toggleReviewFilter (reviewStatusFilterField, reviewStatusValue) {      
      this[reviewStatusFilterField].checked = !this[reviewStatusFilterField].checked
      if (this[reviewStatusFilterField].checked) {
        this.reviewStatusFilter.push(reviewStatusValue)
      } else {
        this.reviewStatusFilter = this.reviewStatusFilter.filter(el => el !== reviewStatusValue)
      }
      if (this.hasAllExpenseAprovalFilter || this.hasAllTransactionsAprovalFilter) {
        this.reviewFilterTypeNormal.checked = true
      } else {
        this.reviewFilterTypeNormal.checked = false
      }
    },

    _checkAllStepsSelected () {
      if (this.allStepsSelected && this.reviewFilterDefaultFlow.checked) {
        this.reviewFilterTypeFunnel.checked = true
      } else {
        this.reviewFilterTypeFunnel.checked = false
      }
  }, 


},
  watch: {
    'reviewFilterDefaultFlow.checked': function (newV, oldV) {
      this._checkAllStepsSelected()
    }
  }
}
